import type { LifestylePreferenceKey } from './types';

export const TOGGLE_KEYS: LifestylePreferenceKey[] = ['pPlaterApproved', 'safeCarsForFamilies'];

export const LIFESTYLE_LABELS: Record<
  LifestylePreferenceKey,
  { label: string | React.ReactNode; tooltipCopy: string }
> = {
  pPlaterApproved: {
    label: (
      <span>
        P-plater approved
        <br />
        (Victoria only)
      </span>
    ),
    tooltipCopy:
      "Some vehicles are prohibited for probationary drivers. See what vehicles you can and can't drive while on your Ps.",
  },
  safeCarsForFamilies: {
    label: 'Safe cars for families',
    tooltipCopy: 'Vehicles that provide good protection for children and passengers in the back seats.',
  },
};
